import { apiPaths } from 'app/services/api';
import React from 'react';
import { MOBILE_REGEX } from '../../smart-kit/Form/gridFormUtils';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

const fields = [
  // { label: 'Gender', key: 'gender', type: 'radio', items: [{ value: 'male', label: 'Male' }, { value: 'female', label: 'Female' }, { value: 'other', label: 'Other' }], validation: { required: false } },
  {
    label: 'Title',
    key: 'title',
    validation: { required: true },
  },
  {
    label: 'Link',
    key: 'link',
    validation: { required: false },
  },
  {
    label: 'Active',
    key: 'active',
    type: 'checkbox',
    validation: { required: false },
  },
  {
    label: 'Image Url',
    key: 'image_url',
    type: 'image',
    purpose: 'banner_pic',
    validation: { required: true },
  },
];
const BannerForm = () => {
  return (
    <CrudGridForm path={apiPaths.BANNERS} name="Banner" entityName={'banners'} fields={fields} />
  );
};

export default BannerForm;
